import { mountReactPages } from "./vibecheck/App"
import { mountAgentCredentialSetup } from "./vibecheck/agentCredentialSetup"

mountReactPages()
mountAgentCredentialSetup()
